import moment from 'moment'
import React, { useEffect, useRef, useState } from 'react'

import { useLoadStripeCustomer } from '@/queries/payments/useLoadStripeCustomer'

import { useAuthContext } from '../../auth/authContext'
import history from '../../utils/history'
import Alert from '../Alert/Alert'

export function SubscriptionAlertHandler() {
  const { isAuthenticated } = useAuthContext()
  const [isClosed, setIsClosed] = useState(false)
  const { data: stripeCustomer } = useLoadStripeCustomer()

  useEffect(() => {
    history.listen(() => {
      setIsClosed(false)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated])

  const message = useRef('')
  const alertType = useRef('')
  const trialPeriod = useRef('')
  const AppBase = process.env.REACT_APP_SITE_URL
  const createCardURL = `${AppBase}/setup-card`

  if (!stripeCustomer) {
    return null
  }

  const {
    subscription_status,
    invoice_payment_status: invoice_status,
    trial_end,
  } = stripeCustomer

  if (subscription_status === 'active') {
    return null
  }

  if (subscription_status === 'trialing') {
    const trialEnd = moment(trial_end)
    const diffDays = trialEnd.diff(moment(), 'days')
    if (diffDays === 0) {
      const diffHours = trialEnd.diff(moment(), 'hours')
      const diffMinutes = trialEnd.diff(moment(), 'minutes')
      trialPeriod.current =
        diffHours > 1 ? `in ${diffHours} hours` : `in ${diffMinutes} minutes`
    } else {
      trialPeriod.current = diffDays > 1 ? `in ${diffDays} days` : 'today'
    }
    message.current = `Your trial period will end ${trialPeriod.current}, please insert your card information by clicking <a href=${createCardURL}>here</a>.`
    alertType.current = 'warning'
  } else if (subscription_status === 'past_due') {
    message.current =
      'Your team subscription has ended. Please insert your card information to continue the subscription.'
    alertType.current = 'error'
  } else if (invoice_status === 'requires_payment_method') {
    message.current = 'Please update your payment information.'
    alertType.current = 'warning'
  }

  return message && alertType ? (
    <Alert
      isClose={isClosed}
      message={message.current}
      onClick={() => setIsClosed(true)}
      type={alertType.current}
    />
  ) : null
}
export default SubscriptionAlertHandler
